module.exports = __webpack_public_path__ + "static/img/leftMenuBg.db64ba4e.png";